export default "/assets/images/mila-sock.jpg?c4a827c40244fcdf40f1709e6d49ce1c";